import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavigationService} from '../services/navigation/navigation.service';
import {Environment} from '../shared/environment/environment';
import {PageNames} from '../shared/page-names.enum';
import {NavigableComponent} from '../model/navigable-component';
import {ProductCarouselComponent} from '../product-carousel/product-carousel.component';
import {ResourceService} from '../services/resource/resource.service';
import {TvShopEntertainmentPack} from '../model/tv-shop-entertainment-pack';
import {TranslateService} from '@ngx-translate/core';
import {CarouselService} from '../services/carousel/carousel.service';
import {AnalyticsService} from '../services/analytics/analytics.service';
import {TvShopStateService} from '../services/state/tv-shop-state.service';
import {NavigablePage} from '../interfaces/navigation/navigable-page.interface';
import {NavigableComponentConfigurationHomePage} from '../constants/navigation/homepage.constants';
import {StreamingServicesUtil} from '../utils/streaming-services.util';
import {NavigationUtil} from '../utils/navigation/navigation.util';
import {OmapiIdsUtils} from '../shared/utils/omapi-ids/omapi-ids-utils';

@Component({
  selector: 'app-tvshop-component',
  templateUrl: './tv-shop-component.html',
  styleUrls: ['./tv-shop-component.less'],
  providers: [NavigationService, Environment, ResourceService]
})
export class TvshopComponent extends NavigableComponent implements OnInit, AfterViewInit, OnDestroy {
  pageConfiguration: NavigablePage = NavigableComponentConfigurationHomePage;
  productsInCarousel: Array<TvShopEntertainmentPack> = [];
  tvPackGroupsInCarousel: Array<TvShopEntertainmentPack> = [];
  streamingBundlesForHeroCarousel: Array<TvShopEntertainmentPack> = [];
  mainPack: TvShopEntertainmentPack;
  ownerComponent: PageNames.HOMEPAGE;

  @ViewChild(ProductCarouselComponent)
  private carouselComponent: ProductCarouselComponent;

  @ViewChild('homepage', {read: ElementRef})
  homepageElement: ElementRef;

  constructor(protected navigationService: NavigationService,
              private translateService: TranslateService,
              private changeDetector: ChangeDetectorRef,
              private carouselService: CarouselService,
              private analyticsService: AnalyticsService,
              private stateService: TvShopStateService
  ) {
    super(navigationService);
    NavigationUtil.processNavigationPage(this.pageConfiguration, this.stateService);
  }

  ngOnInit(): void {
    this.stateService.setIsStreamingBundleOrder(false);
    this.navigationService.setCurrentPageComponent(PageNames.HOMEPAGE);
    this.navigationService.state.infiniteScrolling = true;
    this.processPacks();
    this.processStreamingServices();
    this.processPackGroups();
    setTimeout(() => {
      this.stateService.setLoading(false);
      this.navigationService.resetNavigation();
    }, 200);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.navigationService.clearNavigation();
  }

  ngAfterViewInit(): void {
    this.navigationService.registerPageElement(this.homepageElement);
    this.changeDetector.detectChanges();
  }

  private processPacks(): void {
    const packs = this.stateService.selectSnapshot(state => state.tvShopEntertainmentPacks);
    if (packs.length > 0) {
      this.mainPack = this.carouselService.getMainPack(packs);
      const products = this.carouselService.getProductsInCarousel(packs, this.mainPack);
      this.productsInCarousel = products.sort((a, b) => OmapiIdsUtils.ORDER_PACK.indexOf(a.omapiId) - OmapiIdsUtils.ORDER_PACK.indexOf(b.omapiId));
      const mainPackArray = [this.mainPack];
      this.analyticsService.onHomePageWithProducts(mainPackArray.concat(this.productsInCarousel).map(value => value.omapiId));
      this.doneLoading = true;
    }
  }

  private processStreamingServices(): void {
    const streamingServices = this.stateService.selectSnapshot(state => state.tvShopStreamingServices);
    if (streamingServices.length > 0) {
      this.streamingBundlesForHeroCarousel = StreamingServicesUtil.getStreamingBundles(streamingServices);
      this.carouselService.createCarouselImagesForStreamingServices(this.streamingBundlesForHeroCarousel);
    }
  }

  private processPackGroups(): void {
    const streamingServices = this.stateService.selectSnapshot(state => state.tvShopStreamingServices);
    const groups = this.stateService.selectSnapshot(state => state.tvShopEntertainmentPackGroups);
    if (groups.length > 0) {
      this.tvPackGroupsInCarousel = [StreamingServicesUtil.getNetflixStandaloneGroup(groups), StreamingServicesUtil.getStandAloneDisneyPlus(streamingServices)];
      this.carouselService.createCarouselImagesForStreamingServices(this.tvPackGroupsInCarousel);
    }
  }
}
